export default {
  // 模块名称
  carRecord: {
    // 按钮类
    button: {
      query: '查询',
      reset: '重置',
      export: '导出',
      close: '关闭',
      detail: '查看'
    },
    // 文字标签类
    label: {
      plateCode: '车牌号',
      name: '姓名',
      phone: '电话',
      idCard: '身份证号',
      vehicleType: '车辆类型',
      vehicleColor: '车辆颜色',
      trafficArea: '通行区域',
      vehiclePhoto: '车辆照片',
      desc: '描述',
      approvalStatus: '审批状态',
      approvalOpinions: '审批意见',
      operations: '操作',
      image: '图片',
      workNo: '工号'
    },
    // 提示类
    placeholder: {
      select: '请选择',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: '记录详情'
    }
  }
}